// コンバート取得プロセス
const ConvertProcess = {
  namespaced: true,

  state: {
    process: 0, // コンバート取得実行数
    maxProcess: 3, // コンバート取得実行最大数
  },
  getters: {
    getProcess: state => {
      return state.process
    },
    getMaxProcess: state => {
      return state.maxProcess
    },
  },
  mutations: {
    setProcess(state, process) {
      state.process = process
    },
  },
  actions: {},
}

export default ConvertProcess
